import { forwardRef } from 'react';
//import { useTranslation } from 'react-i18next';
//import loadingImage from '#/assets/images-loading.png';
//import spinnerImage from '#/assets/spinner.png';
import styles from './loading-indicator.module.css';
import { CarouselState } from '../content-carousel';

interface LoadingIndicatorProps {
  state: CarouselState;
}

const LoadingIndicator = forwardRef<HTMLDivElement, LoadingIndicatorProps>(({ state }, ref) => {
  //const { t } = useTranslation();
  return (
    <div
      ref={ref}
      className={`${styles.loadingText} ${styles.cssSpinnerActive} ${![CarouselState.ANALYZING, CarouselState.LOADING, CarouselState.NO_ITEMS].includes(state) ? styles.fadeOut : styles.fadeIn}`}
    >
      {/*(state === CarouselState.ANALYZING || state === CarouselState.LOADING) && (
        <>
          <div className={styles.loadingImageContainer}>
            <img src={loadingImage} alt="Loading" className={styles.loadingImage} />
            <img src={spinnerImage} alt="Loading Spinner" className={styles.loadingSpinnerImage} />
          </div>

          <div className={styles.loader} />

          {state === CarouselState.ANALYZING && <span>{t("analyzingImages")}</span>}
          {state === CarouselState.LOADING && <span>{t("loadingImages")}</span>}
        </>
      )}
      {/*state === CarouselState.NO_ITEMS &&
        <span
          className={styles.noImagesFound}
        >
          {t("noImagesFound")}
        </span>*/}
    </div>
  );
});

LoadingIndicator.displayName = 'LoadingIndicator';

export default LoadingIndicator;